<template>
  <v-flex data-qa="opendeposit-flex-orkze">
    <Loader v-if="loaderEnabled"/>
    <v-layout data-qa="opendeposit-layout-r77pc">
      <Stepper
        :wizardConfig="{
          accountLabel: offerInfo.label,
          steps,
          summaryAdditionalData,
          formData,
          depositAmtError: checkAccountBalance().error,
          termError: checkTermValidation().error,
          currencyFormat: config.productSummary.currencyCode,
          offerInfo: offerInfo,
          payAwayAccount: selectedPayAwayAcc,
          getTermDepositMaturity
        }"
      >
        <v-flex slot="stepperContent" data-qa="opendeposit-flex-otlda">
          <v-form ref="form" v-model="isFormValid" :lazy-validation="false" data-qa="opendeposit-form-15patc">
            <!-- Step 1 Select Funding AC -->
            <v-layout v-show="currentStep === 1" data-qa="opendeposit-layout-mirdwc">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opendeposit-flex-9mwc8s">
                <ListAccounts :config="'fundingAC'" @otherAccounts='fetchOtherAccounts($event)' @sameAccounts='fetchSameAccounts($event)' @beneficiariesList='fetchBeneficiariesList($event)' :currencyFormat="config.productSummary.currencyCode" />
              </v-flex>
            </v-layout>
            <!-- Step 2 Deposit Details -->
            <v-layout v-show="currentStep === 2" data-qa="opendeposit-layout-c9dkn">
              <v-flex xs12 sm12 md7 lg7 xl7 data-qa="opendeposit-flex-heurom">
                <v-flex
                  v-if="formData.fundingAccountType === 'Internal'"
                  class="pb-6"
                 data-qa="opendeposit-flex-0lyzpf">
                  <font class="body-1 font-weight-bold pb-2"
                    >{{ $t('openDepositAcc.amountToDepositLabel') }}</font
                  >
                  <v-flex xs12 sm8 md7 lg10 xl10 data-qa="opendeposit-flex-pg7y99t">
                    <v-text-field
                      v-model="formData.depositAmount"
                      @input="
                        inputHandler();
                        calculateInterestRate();
                      "
                      @keydown="restrictCharacters($event)"
                      :rules="rules"
                      :error="checkAccountBalance().error"
                      :color="primaryColor"
                      :label="deposit.amount ? '' : $t('openDepositAcc.enterAmount')"
                      :error-messages="checkAccountBalance().message"
                      :hint="
                        checkAccountBalance().error
                          ? ''
                          : `Min ${isFormatDecimalRequired(formData.minAmount)} - Max ${isFormatDecimalRequired(formData.maxAmount)}`
                      "
                      persistent-hint
                      filled
                      class="textFieldHighlighter mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                      background-color="#f0eff7"
                      data-qa="enterDepositAmt"
                    />
                  </v-flex>
                </v-flex>
                <v-flex class="pb-4" data-qa="opendeposit-flex-j8t5fg">
                  <font class="body-1 font-weight-bold pb-2"
                    >{{ $t("openDepositAcc.termDescription") }}</font
                  >
                  <v-flex xs12 sm8 md7 lg10 xl10 data-qa="opendeposit-flex-tsbmyl">
                    <v-text-field
                      v-model="formData.selectedTerm"
                      @input="
                        inputHandler();
                        calculateInterestRate();
                      "
                      :disabled="isEndDateCommonForAllAccounts"
                      @click="termListDialog = true"
                      @keydown="selectedTermKeyhandler"
                      :rules="rules"
                      :error="checkTermValidation().error"
                      :error-messages="checkTermValidation().message"
                      :color="primaryColor"
                      :label="deposit.term ? '' : $t('openDepositAcc.selectTerm')"
                      :hint="
                        (checkTermValidation().error || isEndDateCommonForAllAccounts)
                          ? ''
                          : `Min ${formData.minTenor} - Max ${formData.maxTenor}`
                      "
                      persistent-hint
                      filled
                      append-icon="mdi-calendar"
                      background-color="#f0eff7"
                      class="textFieldHighlighter mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto"
                      data-qa="enterDepositTerm"
                    />
                  </v-flex>
                </v-flex>
                <v-row class="mx-0" data-qa="opendeposit-row-v6o4be">
                  <v-flex xs12 sm5 md5 lg6 xl5 class="pl-1" data-qa="opendeposit-flex-jemlar">
                    <font class="font-weight-bold">{{$t('openDepositAcc.interestRate')}}</font>
                    <br data-qa="opendeposit-br-orl9s"  />
                    <span data-qa="opendeposit-span-bh8r6j">
                      <a
                        text
                        class="font-weight-light"
                        :style="{ color: primaryColor }"
                        @click="showInterestRates()"
                         data-qa="opendeposit-a-i4bmaa">{{ $t("applyNow.viewInterestRateLabel") }}
                      </a>
                    </span>
                  </v-flex>
                  <v-flex
                    v-if="formData.fundingAccountType === 'Internal'"
                    xs8 sm3 md2 lg4 xl3
                   data-qa="opendeposit-flex-r5px92o">
                    <v-text-field
                      v-model="formData.interestRate"
                      :color="primaryColor"
                      :readonly="true"
                      outlined
                      class="text-h5 mt-n3 font-weight-bold"
                     data-qa="opendeposit-text-field-e3c2s"></v-text-field>
                    <!-- suffix="%" -->
                  </v-flex>
                </v-row>
              </v-flex>

              <v-dialog
                v-model="termListDialog"
                max-width="300"
                :persistent="true"
               data-qa="opendeposit-dialog-7gexn5">
                <v-card class="pa-4" data-qa="opendeposit-card-5u0xot">
                  <p data-qa="opendeposit-p-trz5po">
                    <font class="body-1 font-weight-medium">{{ $t('openDepositAcc.selectTerm') }}</font>
                  </p>
                  <v-row data-qa="opendeposit-row-1mytpv">
                    <v-col lg="6" data-qa="opendeposit-col-l1vm9">
                      <v-text-field
                        v-model="formData.term"
                        @input="
                          inputHandler();
                          calculateInterestRate();
                        "
                        :color="primaryColor"
                        :error="checkTermValidation().error"
                        :error-messages="checkTermValidation().message"
                         :label="$t('openDepositAcc.term')"
                       data-qa="opendeposit-text-field-hiryvf"></v-text-field>
                    </v-col>
                    <v-col lg="6" data-qa="opendeposit-col-zrn1vx">
                      <v-select
                        v-model="selectedTermOption"
                        @change="termOptionHandler"
                        @input="calculateInterestRate($event);"
                        :items="termInPeriod"
                        :color="primaryColor"
                       data-qa="opendeposit-select-mgrbe9"></v-select>
                    </v-col>
                  </v-row>
                  <v-row justify="end" data-qa="opendeposit-row-c84zqh">
                    <v-card-actions data-qa="opendeposit-card-actions-zkhe5p">
                      <v-btn data-qa="opendeposit-btn-vhyl9l"
                        @click="onTermListDialogClose"
                        :color="primaryColor"
                        text
                        class="text-capitalize"
                        v-text="$t('openDepositAcc.cancelButton')"
                      />
                      <v-btn data-qa="opendeposit-btn-qbvnrk"
                        @click="onSelectTerm"
                        :color="primaryColor"
                        :disabled="checkTermValidation().error || !formData.term"
                        text
                        class="text-capitalize"
                        v-text="$t('openDepositAcc.doneButton')"
                      />
                    </v-card-actions>
                  </v-row>
                </v-card>
              </v-dialog>
            </v-layout>
            <!-- Step 3 Select Maturity Instruction -->
            <v-layout v-show="currentStep === 3" data-qa="opendeposit-layout-1s6ie8">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opendeposit-flex-f7nrcm">
                <v-card elevation="0" data-qa="opendeposit-card-u6texc">
                  <font class="body-1 font-weight-bold"
                    >{{ $t("openDepositAcc.maturitySelectLabel") }}
                  </font>
                  <v-flex xs12 sm10 md10 lg10 xl10 data-qa="opendeposit-flex-t1400l">
                    <v-select
                      v-model="selectedMIlabel"
                      :label="$t('openDepositAcc.selectMaturityInstruction')"
                      :items="getConfiguredMI"
                      :color="primaryColor"
                      @change="getSelectedMaturityOption"
                      :disabled="isEndDateCommonForAllAccounts"
                     data-qa="opendeposit-select-mxn43o"></v-select>
                    <!-- Step 3 Select Pay Away AC -->
                    <v-flex v-if="isPayAwayEnabled" class="mt-6 mb-4" data-qa="opendeposit-flex-rjn88m">
                      <v-tabs
                        @change="changeAccountType"
                        :color="primaryColor"
                        v-model="selectedAccountType"
                       data-qa="opendeposit-tabs-ezv7zk">
                        <v-tab class="text-capitalize font-weight-bold" data-qa="opendeposit-tab-1vwu69">
                          {{ $t("termDepositActions.listAC.internalButtonLabel") }}
                        </v-tab>
                        <v-tab v-if="isViewPayeePermitted" class="text-capitalize font-weight-bold" data-qa="opendeposit-tab-5hi46d">
                          {{ $t("termDepositActions.listAC.externalButtonLabel") }}
                        </v-tab>
                      </v-tabs>
                    </v-flex>
                    <v-flex v-if="selectedAccountType === 0" data-qa="opendeposit-flex-vha1c7">
                      <ListAccountsSelect
                        v-if="isPayAwayDisabled"
                        v-model="selectedPayAwayAcc"
                        :label="$t('openDepositAcc.selectMaturityAccount')"
                        :items="sameAccountsNOCR"
                        @input="setPayAwayAC"
                      />
                      <ListAccountsSelect
                        v-if="isPayAwayEnabled && isAccountPIP"
                        v-model="formData.selectedInterestPayAwayAcc"
                        :label="$t('openDepositAcc.selectInterestPayAwayAcc')"
                        :items="sameAccountsNOCR"
                        @input="setPayAwayAC"
                      />
                    </v-flex>
                    <v-flex v-if="selectedAccountType === 1" data-qa="opendeposit-flex-elvg0f">
                      <ListAccountsSelect
                        v-if="isPayAwayDisabled"
                        v-model="selectedPayAwayAcc"
                        :label="$t('openDepositAcc.selectMaturityAccount')"
                        :items="otherAccounts"
                        :external="true"
                        @input="setPayAwayAC"
                      />
                      <ListAccountsSelect
                        v-if="isPayAwayEnabled && isAccountPIP"
                        v-model="formData.selectedInterestPayAwayAcc"
                        :label="$t('openDepositAcc.selectInterestPayAwayAcc')"
                        :items="otherAccounts"
                        :external="true"
                        @input="setPayAwayAC"
                      />
                    </v-flex>
                  </v-flex>
                </v-card>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </Stepper>
      <!-- Interest Rate Modal for external account -->
      <Modal :config="modalConfig" @cancel="hideInterests">
        <span slot="modalContent" data-qa="opendeposit-span-294yqh">
          <v-data-table
            :headers="headers"
            :items="interestRates"
            multi-sort
            class="elevation-1"
           data-qa="opendeposit-data-table-pruirq"></v-data-table>
        </span>
      </Modal>
      <!-- OTP Section for create TD -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        :config="otpModalConfig"
        @cancel="onOtpModalClose"
      >
        <span slot="modalContent" data-qa="opendeposit-span-bqw6ro">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
    </v-layout>
  </v-flex>
</template>

<script>
import commonService from '@/service/commonService.js'
import event from '@/util/event'
import _ from 'lodash'
import maturityInstructions from '@/../mocks/maturityInstructions.json'
import store from '@/core/store'
import preload from '@/util/preload'
import YM from 'convert-months-year'
import ListAccountsSelect from './ListAccountsSelect.vue'
import moment from 'moment'
const d = new Date()
const month = d.getMonth() + 1
const year = d.getFullYear()

export default {
  name: 'stepper-content',
  props: {
    config: Object
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    ListAccounts: () =>
      import('@/views/accounts/termDepositActions/ListAccounts.vue'),
    Stepper: () =>
      import('@/views/accounts/termDepositActions/OpenDepositStepper.vue'),
    ListAccountsSelect,
    Loader: () => import('@/components/common/Loader.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      isFormValid: true,
      formData: {
        selectedMaturityOption: '',
        maturityInstructions,
        fundingAccountType: '',
        payAwayAccountType: '',
        externalAccounts: [],
        internalAccounts: [],
        currencies: ['GBP'],
        selectedCurrency: 'GBP',
        termOptions: [this.$t('openDepositAcc.termInPeriod.day'), this.$t('openDepositAcc.termInPeriod.month'), this.$t('openDepositAcc.termInPeriod.year')],
        selectedTermOption: this.$t('openDepositAcc.termInPeriod.month'),
        interestRate: '0%',
        defaultPayAwayAccount: true,
        selectedInternalFundingAccount: '',
        selectedExternalFundingAccount: '',
        selectedInternalPayAwayAccount: '',
        selectedExternalPayAwayAccount: '',
        selectedExternalFundingAccBeneficiaryId: '',
        selectedExternalPayAwayBeneficiaryId: '',
        depositAmount: null,
        term: null,
        fundingAccountNumber: '',
        fundingSortCode: '',
        payawayAccountNumber: '',
        payawaySortCode: '',
        accountBalance: '',
        accountCurrency: '',
        payAwayFundingAccount: 'payAwayExternal',
        payAwayFundingAccountValue: '',
        payAwayAccount: '',
        maturityInstructionsValue: '',
        internalFundingAccountBalance: '',
        internalPayawayAccountBalance: '',
        selectedTerm: null,
        maturityAmount: null,
        maturityDate: null,
        minAmount: null,
        maxAmount: null,
        minTenor: null,
        maxTenor: null,
        ownAccounts: [],
        selectedInterestPayAwayAcc: ''
      },
      selectedMIlabel: '',
      interestRates: [],
      requiredExternalFields: [
        'fundingAccountNumber',
        'fundingSortCode',
        'term',
        'selectedTermOption',
        'selectedMaturityOption'
      ],
      requiredInternalFields: [
        'selectedInternalFundingAccount',
        'depositAmount',
        'selectedCurrency',
        'term',
        'selectedTermOption',
        'selectedMaturityOption'
      ],
      rules: [(v) => Boolean(v) || 'Required'],
      offerInfo: null,
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForCreateTD,
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      minProductTermInDays: 0,
      maxProductTermInDays: 0,
      termInDays: 0,
      isBeneficiaryAccountCreated: true,
      isAllFieldsValid: false,
      otpModalConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      modalConfig: {
        enabled: false,
        persistent: false,
        close: true,
        outlinedSaveBtn: true,
        title: this.$t('applyNow.modalTitle'),
        width: 800
      },
      headers: [
        { text: this.$t('openDepositAcc.interestRateHeader.minimumAmount'), value: 'minAmount' },
        { text: this.$t('openDepositAcc.interestRateHeader.maximumAmount'), value: 'maxAmount' },
        { text: this.$t('openDepositAcc.interestRateHeader.minimumTenor'), value: 'minTenor' },
        { text: this.$t('openDepositAcc.interestRateHeader.maximumTenor'), value: 'maxTenor' },
        { text: this.$t('openDepositAcc.interestRateHeader.effectiveInterestRate'), value: 'effectiveIR' }
      ],
      steps: [
        { id: 1, name: 'openTDAccStep1', value: '' },
        { id: 2, name: 'openTDAccStep2', value: '' },
        { id: 3, name: 'openTDAccStep3', value: '' }
        // DOB-642 changes { id: 4, name: 'openTDAccStep4', value: '' }
      ],
      summaryAdditionalData: [
        { id: '5', label: this.$t('openDepositAcc.maturityAmount'), value: '' },
        { id: '6', label: this.$t('openDepositAcc.maturityDate'), value: '' }
      ],
      maturityDetails: undefined,
      currentStep: 1,
      termListDialog: false,
      deposit: {
        amount: undefined,
        term: undefined,
        rateOfInterest: undefined
      },
      termInPeriod: [this.$t('openDepositAcc.termInPeriodMore.day'), this.$t('openDepositAcc.termInPeriodMore.month'), this.$t('openDepositAcc.termInPeriodMore.year')],
      otherAccounts: [],
      sameAccountsNOCR: [],
      beneficiariesList: [],
      selectedAccountType: 0,
      selectedPayAwayAcc: '',
      selectedTermOption: this.$t('openDepositAcc.termInPeriodMore.month'),
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      isEndDateCommonForAllAccounts: false,
      formDataLoading: false,
      enableTCForAccountOpening: this.$appSettings.defaultConfigurations.consentManagement.enableTCForAccountOpening,
      isDecimalRequiredForMinMaxAmount: this.$appSettings.defaultConfigurations.showDecimalPartInOpenAcountMinMaxAmount,
      defaultBranchCode: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.branchCode,
      permissions: [],
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  created () {
    const self = this
    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.showOTPScreen = false
    this.formData.selectedCurrency = self.config.productSummary.currencyCode
    if (this.currentStep > 0) {
      this.inputHandler()
    }
    if (this.config !== undefined) {
      this.offerInfo = this.config
      this.formData.minAmount = this.$formatter.currency.format(
        this.offerInfo.minAmount[0].value, this.offerInfo.minAmount[0].currency
      )
      this.formData.maxAmount = this.$formatter.currency.format(
        this.offerInfo.maxAmount[0].value, this.offerInfo.minAmount[0].currency
      )
      this.formData.minTenor = this.getFormattedTenor(this.offerInfo.minTenor[0].value, this.offerInfo.minTenor[0].frequency)
      this.formData.maxTenor = this.getFormattedTenor(this.offerInfo.maxTenor[0].value, this.offerInfo.maxTenor[0].frequency)
    } else {
      this.offerInfo = {}
    }
    this.getProductTermDetails()
    this.configureMaturityInstruction(self.config.interestPayoutMethod)
    const { productSummary: { isEndDateCommonForAllAccounts = false, productEndDate } = {} } = this.config
    this.formData.isEndDateCommonForAllAccounts = isEndDateCommonForAllAccounts
    this.formData.productEndDate = productEndDate
    this.isEndDateCommonForAllAccounts = isEndDateCommonForAllAccounts
    if (this.isEndDateCommonForAllAccounts && !this.isAccountPIP) this.steps = this.steps.slice(0, 2)

    event.$on('onNextStep', async (arg) => {
      this.currentStep = arg
      if (this.currentStep === 2 && this.isEndDateCommonForAllAccounts) {
        // calculate the term in a particular format ie; > 365 days ? [X Years & Y Days]
        this.formData.term = moment(productEndDate).diff(moment().format('YYYY-MM-DD'), 'days')
        this.formData.selectedTermOption = 'Days'
        this.formData.selectedTerm = this.formData.term > 365 ? this.getFormattedTenor(this.formData.term) : this.getFormattedTenor(this.formData.term, this.formData.selectedTermOption)
        this.selectedMIlabel = 'Not Decided yet'
        this.getSelectedMaturityOption()
      }
      if (this.currentStep === this.steps.length) {
        this.formData.fundingAccountType !== 'External' && await
        this.getTermDepositMaturity()
        event.$emit('enableNextBtn', true)
      }
    })
    event.$on('onPreviousStep', (arg) => {
      this.currentStep = arg
    })
    event.$on('listAccounts', (args) => {
      args.accType === 'fundingAC' && this.setFundingAC(args)
      args.accType === 'payAwayAC' && this.setPayAwayAC(args)
    })
    event.$on('clearAccountsDetails', (args) => {
      this.clearAccounts(args)
    })
    event.$on('createTermDepositAC', (arg) => {
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.otpModalConfig.enabled = true
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 100)
      } else {
        this.createTermDeposit()
      }
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.enableOTP && this.showOTPScreen) {
        this.otpModalConfig.enabled = false
        this.createTermDeposit()
      } else {
        this.otpModalConfig.enableSave = true
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.otpModalConfig.enableSave = true
    })
  },
  computed: {
    getConfiguredMI () {
      let temp = []
      if (this.formData.maturityInstructions && this.formData.maturityInstructions.length) {
        temp = this.formData.maturityInstructions.map(item => {
          return item.value
        })
        return temp
      }
      return temp
    },
    isMIrestricted () {
      const Mi = ['CAPITALISE', 'CAPTALISE', 'NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
      return Mi.includes(this.formData.selectedMaturityOption)
    },
    isPayAwayDisabled () {
      return this.formData.selectedMaturityOption ? !this.isMIrestricted : false
    },
    isPayAwayEnabled () {
      if (this.offerInfo && this.formData.selectedMaturityOption) {
        if (this.offerInfo.interestPayoutMethod === 'PIP') return true
        else return !this.isMIrestricted
      }
      return false
    },
    isAccountPIP () {
      return this.offerInfo?.interestPayoutMethod === 'PIP'
    },
    isViewPayeePermitted () {
      return this.isSmePermissionCheckEnabled ? this.permissions?.includes('VIEW_PAYEES') : true
    }
  },
  methods: {
    isSmePermissionCheckEnabled: () => this.isSmeLogin && this.enableRoleBasedAccess,
    onOtpModalClose () {
      this.otpModalConfig.enabled = false
      this.showOTPScreen = false
    },
    selectedTermKeyhandler (event) {
      event.preventDefault()
    },
    onSelectTerm () {
      if (this.formData.term) {
        if (this.formData.term > 1) {
          this.formData.selectedTerm = `${this.formData.term} ${this.formData.selectedTermOption}`
        } else {
          const editedText = this.formData.selectedTermOption.slice(0, -1)
          this.formData.selectedTerm = `${this.formData.term} ${editedText}`
        }
      }
      this.termListDialog = false
    },
    onTermListDialogClose () {
      this.formData.term = this.formData.term || null
      this.formData.selectedTermOption = this.formData.selectedTermOption || 'Months'
      this.onSelectTerm()
    },
    removeSymbol (stringData) {
      return stringData.replace('%', '')
    },
    isFormatDecimalRequired (value) {
      return this.isDecimalRequiredForMinMaxAmount ? value : this.$formatter.currency.format(value, this.formData.selectedCurrency, false)
    },
    clearAccounts (props) {
      const self = this
      self.formData.internalAccounts = props.internalAccounts
      self.formData.externalAccounts = props.externalAccounts
      if (props.clearAccDetailsType === 'fundingAC') {
        self.formData.fundingAccountType = props.selectedAccountType
        self.formData.selectedExternalFundingAccount = ''
        self.formData.selectedInternalFundingAccount = ''
        self.formData.isFundingAccOwn = ''
      }
      if (props.clearAccDetailsType === 'payAwayAC') {
        self.formData.payAwayAccountType = props.selectedAccountType
        self.formData.selectedExternalPayAwayAccount = ''
        self.formData.payawaySortCode = ''
        self.formData.selectedInternalPayAwayAccount = ''
        self.formData.isPayAwayAccOwn = ''
        self.formData.isInterestPayAwayAccOwn = ''
      }
    },
    setFundingAC (args) {
      const self = this
      self.formData.fundingAccountType = args.selectedAccountType
      self.formData.payAwayAccountType = args.selectedAccountType // DOB-642 changes
      if (args.selectedAccountType === 'Internal') {
        self.formData.selectedExternalFundingAccount = ''
        self.formData.selectedExternalFundingAccBeneficiaryId = ''
        self.formData.isFundingAccOwn = ''
        self.formData.selectedInternalFundingAccount =
          args.selectedInternalPayAwayAccount
        this.onInternalFundingAccountChange(
          self.formData.selectedInternalFundingAccount
        )
      }
      if (args.selectedAccountType === 'External') {
        self.formData.selectedInternalFundingAccount = ''
        self.formData.selectedExternalFundingAccount =
          args.selectedExternalPayAwayAccount.accountIdentification
        self.formData.fundingSortCode =
          args.selectedExternalPayAwayAccount.bankIdentifier
        self.formData.selectedExternalFundingAccBeneficiaryId =
          args.selectedExternalPayAwayAccount.beneficiaryId
        if (this.nominatedAccountsConfig.enableNominatedAccountFeatures) {
          self.formData.isFundingAccOwn = args.selectedExternalPayAwayAccount.ownAccount
        }
      }
      event.$emit('payAwayAccType', {
        accType: self.formData.fundingAccountType,
        action: 'Create'
      })
    },
    updateBenificiaryDetails () {
      const self = this
      if (this.selectedPayAwayAcc) {
        const beneficiaryDetails = _.find(self.beneficiariesList, o => {
          return o.accountIdentification === this.selectedPayAwayAcc.split('-')[0].trim()
        })
        return beneficiaryDetails
      }
      return null
    },
    updateInterestPayOutDetails () {
      const self = this
      if (this.isAccountPIP && this.formData.selectedInterestPayAwayAcc) {
        const beneficiaryDetails = _.find(self.beneficiariesList, o => {
          return o.accountIdentification === this.formData.selectedInterestPayAwayAcc
        })
        return beneficiaryDetails
      }
      return null
    },
    setPayAwayAC (args) {
      const self = this
      self.formData.payAwayAccountType = self.selectedAccountType === 0 ? 'Internal' : 'External'
      if (self.selectedAccountType === 0) {
        self.formData.selectedExternalPayAwayAccount = ''
        self.formData.payawaySortCode = ''
        self.formData.selectedExternalPayAwayBeneficiaryId = ''
        self.formData.isPayAwayAccOwn = ''
        self.formData.isInterestPayAwayAccOwn = ''
        if (this.selectedPayAwayAcc) {
          self.formData.selectedInternalPayAwayAccount = this.selectedPayAwayAcc
        } else self.formData.selectedInternalPayAwayAccount = ''
        if (this.isAccountPIP) {
          if (this.formData.selectedInterestPayAwayAcc) {
            self.formData.selectedInternalInterestPayAwayAccount = this.formData.selectedInterestPayAwayAcc
          } else self.formData.selectedInternalInterestPayAwayAccount = ''
        }
      }
      if (self.selectedAccountType === 1) {
        const beneficiaryDetails = this.updateBenificiaryDetails()
        const interestPayOutDetails = this.updateInterestPayOutDetails()
        self.formData.selectedInternalPayAwayAccount = ''
        if (beneficiaryDetails) {
          self.formData.selectedExternalPayAwayAccount = beneficiaryDetails.accountIdentification
          self.formData.payawaySortCode = beneficiaryDetails.bankIdentifier
          self.formData.selectedExternalPayAwayBeneficiaryId = beneficiaryDetails.beneficiaryId
        }
        if (this.isAccountPIP && interestPayOutDetails) {
          self.formData.selectedExternalInterestPayAwayBeneficiaryId = interestPayOutDetails.beneficiaryId
        }
      }
      if (self.selectedAccountType === 1) {
        if (this.selectedPayAwayAcc) {
          self.formData.isPayAwayAccOwn = self.formData.ownAccounts.includes(this.selectedPayAwayAcc.split(' ')[0])
        }
        if (this.formData.selectedInterestPayAwayAcc) {
          self.formData.isInterestPayAwayAccOwn = self.formData.ownAccounts.includes(this.formData.selectedInterestPayAwayAcc)
        }
      }
    },
    showInterestRates () {
      this.interestRates = []
      this.modalConfig.enabled = true
      if (!this.offerInfo.interestRates) {
        this.getTDInterestRates()
      } else {
        this.interestRates = this.offerInfo.interestRates
      }
    },
    getTDInterestRates () {
      const self = this
      self.getTermDepositInterestRates().then((res) => {
        for (const i in res.interestRateTiers) {
          const calculatedInterests = {
            ...res.interestRateTiers[i],
            minMaxAmount: `${self.$formatter.currency.format(
                  res.interestRateTiers[i].balanceFrom, this.offerInfo.minAmount[0].currency
                )} - ${self.$formatter.currency.format(
                  res.interestRateTiers[i].balanceTo, this.offerInfo.minAmount[0].currency
                )}`,
            minMaxTenor: `${
                  res.interestRateTiers[i].tenorFrom + ' ' + res.duration
                } - ${res.interestRateTiers[i].tenorTo + ' ' + res.duration}`,
            minAmount: self.$formatter.currency.format(
              res.interestRateTiers[i].balanceFrom, this.offerInfo.minAmount[0].currency
            ),
            maxAmount: self.$formatter.currency.format(
              res.interestRateTiers[i].balanceTo, this.offerInfo.minAmount[0].currency
            ),
            minTenor: res.interestRateTiers[i].tenorFrom + ' ' + res.duration,
            maxTenor: res.interestRateTiers[i].tenorTo + ' ' + res.duration,
            effectiveIR: res.interestRateTiers[i].interestRate + '%'
          }
          self.interestRates.push(calculatedInterests)
        }
        self.offerInfo.interestRates = self.interestRates
        this.cacheInterestRates()
      })
    },
    cacheInterestRates () {
      const self = this
      const profileStore = store.getters['profileStore/profileData']
      const products = profileStore.depositProducts || []
      products.map((val) => {
        if (val.offerId === this.offerInfo.offerId) {
          val.interestRates = self.offerInfo.interestRates
        }
      })
      store.dispatch('profileStore/setProfileData', { depositProducts: products })
    },
    hideInterests () {
      this.modalConfig.enabled = false
    },
    restrictCharacters (keyVal) {
      const partyPreferredLocale = store.getters['profileStore/profileData'].preferredLocale
      const excludeKeyCodes = [8, 37, 39]
      let pattern = /[0-9.]/
      if (partyPreferredLocale === 'de-DE') {
        pattern = /[0-9,]/
      }
      if (!pattern.test(keyVal.key) && !excludeKeyCodes.includes(keyVal.keyCode)) {
        keyVal.preventDefault()
      }
    },
    async calculateInterestRate (param) {
      const self = this
      self.formData.interestRate = '0%'
      if (
        this.formData.fundingAccountType === 'Internal' &&
        self.formData.depositAmount &&
        self.formData.term
      ) {
        if (!this.offerInfo.interestRates) {
          await this.getTermDepositInterestRates().then((res) => {
            for (const i in res.interestRateTiers) {
              const calculatedInterests = {
                ...res.interestRateTiers[i],
                minMaxAmount: `${self.$formatter.currency.format(
                      res.interestRateTiers[i].balanceFrom, this.offerInfo.minAmount[0].currency
                    )} - ${self.$formatter.currency.format(
                      res.interestRateTiers[i].balanceTo, this.offerInfo.minAmount[0].currency
                    )}`,
                minMaxTenor: `${
                      res.interestRateTiers[i].tenorFrom + ' ' + res.duration
                    } - ${res.interestRateTiers[i].tenorTo + ' ' + res.duration}`,
                minAmount: self.$formatter.currency.format(
                  res.interestRateTiers[i].balanceFrom, this.offerInfo.minAmount[0].currency
                ),
                maxAmount: self.$formatter.currency.format(
                  res.interestRateTiers[i].balanceTo, this.offerInfo.minAmount[0].currency
                ),
                minTenor:
                  res.interestRateTiers[i].tenorFrom + ' ' + res.duration,
                maxTenor: res.interestRateTiers[i].tenorTo + ' ' + res.duration,
                effectiveIR: res.interestRateTiers[i].interestRate + '%'
              }
              self.interestRates.push(calculatedInterests)
            }
            self.offerInfo.interestRates = self.interestRates
            self.cacheInterestRates()
            self.setInterestRate(param)
          })
        } else {
          self.setInterestRate(param)
        }
      }
    },
    setInterestRate (param) {
      const self = this
      let termInDays = 0
      let currentYear
      if (param) {
        this.formData.selectedTermOption = param.replace(/[^a-zA-Z ]/g, '')
      }
      switch (self.formData.selectedTermOption) {
        case 'Months':
          for (let i = 0; i < self.formData.term; i++) {
            termInDays = termInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'Years':
          currentYear = year
          for (let i = 0; i < self.formData.term; i++) {
            if (YM.isLeapYear(currentYear)) {
              termInDays = termInDays + 366
            } else {
              termInDays = termInDays + 365
            }
            currentYear++
          }
          break
        default:
          termInDays = self.formData.term
      }
      self.termInDays = termInDays
      if (self.formData.depositAmount && self.formData.term) {
        const x = _.find(self.offerInfo.interestRates, (o) => {
          return (
            parseFloat(self.formData.depositAmount) >= parseFloat(o.balanceFrom) &&
            parseFloat(self.formData.depositAmount) < parseFloat(o.balanceTo) &&
            parseFloat(self.termInDays) >= parseFloat(o.tenorFrom) &&
            parseFloat(self.termInDays) < parseFloat(o.tenorTo)
          )
        })
        if (x && x.interestRate) {
          this.formData.interestRate = x.interestRate + '%'
        } else {
          this.formData.interestRate = '0%'
        }
      }
    },
    async getTermDepositInterestRates () {
      return await commonService.getTermDepositInterestRates(
        this.offerInfo.interestRateId
      )
    },
    async getTermDepositMaturity () {
      const termOption =
        this.formData.selectedTermOption === 'Months'
          ? 'MONTH'
          : this.formData.selectedTermOption === 'Years'
            ? 'YEAR'
            : 'DAY'
      const maturityPayload = {
        subProduct: this.offerInfo.offerId,
        termDepositAmount: {
          currency: this.formData.selectedCurrency,
          value: (this.formData?.depositAmount ? this.formData.depositAmount.toString().replace(',', '.') : 0)
        },
        tenor: {
          value: parseInt(this.formData.term),
          frequency: termOption // frequency in API format
        },
        marginType: 'FLATVALUE',
        margin: '0'
      }
      const response = await commonService.getTermDepositMaturity(
        maturityPayload
      )
      if (response && !response.causes && !response.data) {
        this.formData.maturityAmount = response.maturityAmount.value
        this.formData.maturityDate = response.maturityDate
      }
    },
    async getActiveCurrencyFromService () {
      const response = await commonService.getActiveCurrencyFromService()
      this.formData.currencies = response.items
      return this.formData.currencies
    },
    async getAccountBalances (accountNumber) {
      const response = await commonService.getAccountBalances(accountNumber)
      if (response.balances) {
        return response.balances
      }
    },
    getSelectedMaturityOption () {
      if (this.formData.maturityInstructions && this.formData.maturityInstructions.length) {
        const Mi = ['CAPITALISE', 'CAPTALISE', 'PAYAWAY-PARTIAL', 'PAYAWAYPARTIAL', 'NO-INSTRUCTION', 'NOINSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE', 'NOTAPPLICABLE']
        for (const item of this.formData.maturityInstructions) {
          if (item.value === this.selectedMIlabel) {
            this.formData.selectedMaturityOption = item.key
            break
          }
        }
        if (this.formData.selectedMaturityOption && Mi.includes(this.formData.selectedMaturityOption)) {
          this.selectedPayAwayAcc = ''
          this.formData.selectedExternalPayAwayAccount = ''
          this.formData.selectedExternalPayAwayBeneficiaryId = ''
          this.formData.selectedInternalPayAwayAccount = ''
          this.formData.payawaySortCode = ''
        }
      }
      if (!this.isAccountPIP) this.formData.selectedInterestPayAwayAcc = ''
    },
    setSelectedMaturityOption () {
      if (this.formData.selectedMaturityOption === 'PAYAWAY-PARTIAL') {
        return 'CAPITALISE'
      } else return this.formData.selectedMaturityOption
    },
    async createTermDeposit () {
      const { accountOperationTypeDetails: { selectedAccountOperationType = 'SOLE', selectedJointAccountHolder = null, selectedModeOfOperation = 'SOLE' } = {} } = this.config
      this.onOtpModalClose()
      this.loaderEnabled = true
      const self = this
      const termOption =
        this.formData.selectedTermOption === 'Months'
          ? 'MONTH'
          : this.formData.selectedTermOption === 'Years'
            ? 'YEAR'
            : 'DAY'
      const data = {
        customerId: JSON.parse(sessionStorage.getItem('username')),
        branchCode: this.defaultBranchCode,
        productId: this.offerInfo.offerId,
        startDate: new Date().toISOString().substr(0, 10),
        tenor: {
          frequency: termOption,
          value: parseInt(this.formData.term)
        },
        principal: {
          value:
            this.formData.fundingAccountType === 'External'
              ? '0'
              : parseFloat(this.formData.depositAmount),
          currency: this.formData.selectedCurrency
        },
        maturityInstructions: this.setSelectedMaturityOption(),
        accountOwnership: selectedAccountOperationType,
        jointCustomerDetails: selectedJointAccountHolder?.jointCustomerId ? [{ customerId: selectedJointAccountHolder.jointCustomerId }] : null,
        modeOfOperation: selectedModeOfOperation,
        mandateDetails: null,
        postingsRestriction: 'NONE'
      }

      const selectedMI = data.maturityInstructions
      const isPayawayAccTypeInternal = self.formData.payAwayAccountType === 'Internal'
      const principalPayawayId = isPayawayAccTypeInternal ? self.formData.selectedInternalPayAwayAccount : self.formData.selectedExternalPayAwayBeneficiaryId
      const interestPayawayId = isPayawayAccTypeInternal ? self.formData.selectedInternalInterestPayAwayAccount : self.formData.selectedExternalInterestPayAwayBeneficiaryId

      data.fundingAccountId = self.formData.fundingAccountType === 'Internal' ? self.formData.selectedInternalFundingAccount : self.formData.selectedExternalFundingAccount
      data[isPayawayAccTypeInternal ? 'principalPayawayAccountId' : 'principalPayawayBeneficiaryId'] = selectedMI === 'PAYAWAY-INTEREST' ? '' : principalPayawayId || ''
      data[isPayawayAccTypeInternal ? 'interestPayawayAccountId' : 'interestPayawayBeneficiaryId'] = selectedMI === 'PAYAWAY-PRINCIPAL' && !self.isAccountPIP ? ''
        : self.isAccountPIP ? interestPayawayId
          : principalPayawayId || ''

      if (this.$route.params?.additionalDetails) {
        data['custom-fields'] = {
          additionalProperties: this.$route.params.additionalDetails
        }
      }
      const resp = await commonService.createTermDepositAccount(data)
      if (resp && !resp.causes) {
        await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
        const getConfirmData = this.getFormData(resp)
        if (this.enableTCForAccountOpening && getConfirmData?.accountDetails?.accountId) {
          const consentInfo = {
            consentEntityId: getConfirmData?.accountDetails?.accountId,
            consentEntityType: 'ACCOUNT',
            consentGivenBy: JSON.parse(sessionStorage.getItem('username')),
            channelCode: 'DOB',
            consents: this.offerInfo.consent
          }
          await commonService.storeEntityConsent(consentInfo)
        }
        event.$emit('onTermDepositACCreation', getConfirmData)
      } else {
        event.$emit('disableOpenDesositNextBtn', true)
      }
      this.loaderEnabled = false
    },
    getFormData (respData) {
      let tenorFrequency = ''
      tenorFrequency = this.$t(`productList.units.${respData?.tenor?.frequency}`)
      tenorFrequency =
        parseInt(respData?.tenor?.value) > 1
          ? `${tenorFrequency}s`
          : tenorFrequency
      const confirmData = {
        accountDetails: {
          accountId: respData.accountId,
          sortCode: this.$appSettings.defaultConfigurations.sortCode,
          accountStatus: this.$t(`systemEnums.termDeposit.${respData.status}`),
          principalAmount: this.$formatter.currency.format(
            respData.principal?.value, this.config.productSummary.currencyCode
          ),
          interestRate: `${respData.interestRate} %`,
          tenor: respData.tenor.value + ' ' + tenorFrequency,
          startDate: this.$formatter.formatDate(respData.startDate),
          interestPayout: respData.interestPayout || 'Monthly',
          fundingAccount:
            this.formData.fundingAccountType === 'External'
              ? this.formData.selectedExternalFundingAccount
              : this.formData.selectedInternalFundingAccount,
          isFundingAccOwn: this.formData.isFundingAccOwn,
          isPayAwayAccOwn: this.formData.isPayAwayAccOwn,
          isInterestPayAwayAccOwn: this.formData.isInterestPayAwayAccOwn
        },
        maturityDetails: {
          maturityAmount: this.$formatter.currency.customFormatter(
            respData.maturityAmount.value, this.config.productSummary.currencyCode
          ),
          maturityDate: this.$formatter.formatDate(respData.maturityDate),
          onMaturity: this.$t(
            `systemEnums.maturityInstructions.${respData.maturityInstructions}`
          ),
          payAwayAccount: this.selectedPayAwayAcc,
          payInterestToAccount: this.formData.selectedInterestPayAwayAcc
        },
        currentBalance: { value: respData.principal.value },
        maturityAmount: { value: respData.maturityAmount.value }
      }

      if (respData?.accountOwnership === 'JOINT') {
        const { modeOfOperation, jointCustomerDetails, accountOwnership } = respData
        confirmData.accountDetails.modeOfOperation = modeOfOperation
        confirmData.accountDetails.jointCustomerDetails = `${jointCustomerDetails[0]?.jointCustomerName} - ${jointCustomerDetails[0]?.jointCustomerId}`
        confirmData.accountDetails.accountOwnership = accountOwnership
      }
      return confirmData
    },
    async onInternalFundingAccountChange () {
      const balances = await this.getAccountBalances(
        this.formData.selectedInternalFundingAccount
      )
      const bal = _.find(balances, (o) => {
        return o.balanceType === 'INTERIMCLEARED'
      })
      this.formData.internalFundingAccountBalance = bal.amount.amount
      if (this.formData.selectedInternalFundingAccount) {
        this.formData.depositAmount = null
        this.formData.selectedTerm = null
        this.formData.term = null
        this.formData.selectedTermOption = 'Months'
        this.formData.interestRate = '0%'
      }
    },
    inputHandler () {
      const self = this
      this.checkFieldValidations()
      event.$emit('isDepositOpeningPristine', true)
      setTimeout(() => {
        if (self.formData.fundingAccountType === 'External') {
          this.isBeneficiaryAccountCreated = !!self.formData.externalAccounts
            .length
        }
      }, 100)
    },
    checkAccountBalance () {
      let pattern = /^\d*(\.\d{1,2})?$/
      let depositAmount = this.formData.depositAmount
      const partyPreferredLocale = store.getters['profileStore/profileData'].preferredLocale
      if (partyPreferredLocale === 'de-DE') {
        pattern = /^\d*(,\d{1,2})?$/
        depositAmount = (this.formData.depositAmount) ? this.formData.depositAmount.toString().replace(',', '.') : ''
      }
      if (
        this.formData.depositAmount &&
        !pattern.test(this.formData.depositAmount)
      ) {
        return {
          error: true,
          message: this.$t('openDepositAcc.invalidInput')
        }
      }
      if (parseFloat(depositAmount) === 0) {
        return {
          error: true,
          message: this.$t('openDepositAcc.zeroBalError')
        }
      }
      if (this.formData.fundingAccountType === 'Internal') {
        if (
          this.formData.internalFundingAccountBalance &&
          parseFloat(depositAmount) >
            parseFloat(this.formData.internalFundingAccountBalance)
        ) {
          return {
            error: true,
            message: this.$t('openDepositAcc.availableAccountBalance')
          }
        }
        if (
          parseFloat(depositAmount) <
          parseFloat(this.offerInfo.minAmount[0].value)
        ) {
          return {
            error: true,
            message: this.$t('openDepositAcc.minDepositAmountError')
          }
        }
        if (
          parseFloat(depositAmount) >
          parseFloat(this.offerInfo.maxAmount[0].value)
        ) {
          return {
            error: true,
            message: this.$t('openDepositAcc.maxDepositAmountError')
          }
        }
      }
      if (this.formData.fundingAccountType === 'External') {
        if (
          parseFloat(depositAmount) <
          parseFloat(this.offerInfo.minAmount[0].value)
        ) {
          return {
            error: true,
            message: this.$t('openDepositAcc.minDepositAmountError')
          }
        }
        if (
          parseFloat(depositAmount) >
          parseFloat(this.offerInfo.maxAmount[0].value)
        ) {
          return {
            error: true,
            message: this.$t('openDepositAcc.maxDepositAmountError')
          }
        }
      }
      return {
        error: false,
        message: ''
      }
    },
    checkTermValidation () {
      let termInDays = 0
      let currentYear
      if (this.formData.term && !/^\d+$/.test(this.formData.term)) {
        return {
          error: true,
          message: this.$t('openDepositAcc.invalidInput')
        }
      }
      if (parseFloat(this.formData.term) === 0) {
        return {
          error: true,
          message: this.$t('openDepositAcc.zeroTermError')
        }
      }

      switch (this.formData.selectedTermOption) {
        case 'Months':
          for (let i = 0; i < this.formData.term; i++) {
            termInDays = termInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'Years':
          currentYear = year
          for (let i = 0; i < this.formData.term; i++) {
            if (YM.isLeapYear(currentYear)) {
              termInDays = termInDays + 366
            } else {
              termInDays = termInDays + 365
            }
            currentYear++
          }
          break
        default:
          termInDays = this.formData.term
      }
      this.termInDays = termInDays
      if (
        parseFloat(termInDays) &&
        parseFloat(termInDays) < parseFloat(this.minProductTermInDays)
      ) {
        return {
          error: true,
          message: this.$t('openDepositAcc.minTermError')
        }
      }
      if (
        parseFloat(termInDays) &&
        parseFloat(termInDays) > parseFloat(this.maxProductTermInDays)
      ) {
        return {
          error: true,
          message: this.$t('openDepositAcc.maxTermError')
        }
      }
      return {
        error: false,
        message: ''
      }
    },
    configureMaturityInstruction (type) {
      const a = JSON.stringify(this.formData.maturityInstructions)
      const b = JSON.parse(a)
      switch (type) {
        case 'CUMULATIVE':
        case 'Cumulative':
          _.remove(b, (o) => {
            return (
              o.key === 'PAYAWAY-INTEREST' || o.key === 'PAYAWAY-PRINCIPAL' || o.key === 'PAYAWAY-PARTIAL'
            )
          })
          this.formData.maturityInstructions = b
          break
        case 'PERIODIC':
        case 'Periodic':
        case 'PIP':
          _.remove(b, (o) => {
            return o.key === 'PAYAWAY-INTEREST' || o.key === 'PAYAWAY-BOTH' || o.key === 'PAYAWAY-PARTIAL'
          })
          this.formData.maturityInstructions = b
          break
        default:
          _.remove(b, (o) => {
            return o.key === 'PAYAWAY-PARTIAL'
          })
          this.formData.maturityInstructions = b
          break
      }
      for (const item of this.formData.maturityInstructions) {
        item.value = type === 'PIP' && item.key === 'PAYAWAY-PRINCIPAL' ? this.$t('systemEnums.maturityInstructions.PIP-PAYAWAY-PRINCIPAL') : this.$t(`systemEnums.maturityInstructions.${item.key}`)
      }
    },
    getProductTermDetails () {
      let currentYear
      switch (this.offerInfo.minTenor[0].frequency) {
        case 'MONTHS':
          for (let i = 0; i < this.offerInfo.minTenor[0].value; i++) {
            this.minProductTermInDays =
              this.minProductTermInDays + YM.daysInMonth(month + i, year)
          }
          for (let i = 0; i < this.offerInfo.maxTenor[0].value; i++) {
            this.maxProductTermInDays =
              this.maxProductTermInDays + YM.daysInMonth(month + i, year)
          }
          break
        case 'YEARS':
          currentYear = year
          for (let i = 0; i < this.offerInfo.minTenor[0].value; i++) {
            if (YM.isLeapYear(currentYear)) {
              this.minProductTermInDays = this.minProductTermInDays + 366
            } else {
              this.minProductTermInDays = this.minProductTermInDays + 365
            }
            currentYear++
          }
          currentYear = year
          for (let i = 0; i < this.offerInfo.maxTenor[0].value; i++) {
            if (YM.isLeapYear(currentYear)) {
              this.maxProductTermInDays = this.maxProductTermInDays + 366
            } else {
              this.maxProductTermInDays = this.maxProductTermInDays + 365
            }
            currentYear++
          }
          break
        default:
          this.minProductTermInDays = this.offerInfo.minTenor[0].value
          this.maxProductTermInDays = this.offerInfo.maxTenor[0].value
      }
    },
    checkFieldValidations () {
      this.isAllFieldsValid = !!(
        !this.checkAccountBalance().error && !this.checkTermValidation().error
      )
    },
    getFormattedTenor (value, frequency = 'Days') {
      if (this.isEndDateCommonForAllAccounts && value > 365) {
        const numberOfYears = Math.floor(this.formData.term / 365)
        const daysLeft = this.formData.term % 365
        return `${numberOfYears} ${numberOfYears > 1 ? this.$t('productList.units.YEARS') : this.$t('productList.units.YEAR')} & ${daysLeft} ${daysLeft > 1 ? this.$t('productList.units.DAYS') : this.$t('productList.units.DAY')}`
      }
      const tenorFrequency = value > 1 ? _.capitalize(frequency)
        : _.capitalize(frequency).slice(0, -1)
      return `${value} ${tenorFrequency}`
    },
    fetchOtherAccounts (accounts) {
      const filteredAccounts = accounts.filter(a => a.currency === this.config.productSummary.currencyCode)

      this.otherAccounts = filteredAccounts
        .filter(a => !this.nominatedAccountsConfig.enableNominatedAccountFeatures || a.ownAccount)
        .map(a => ({
          ...a,
          value: `${a.accountIdentification} - ${a.bankIdentifier}`,
          text: `${a.accountIdentification} - ${a.bankIdentifier}`
        }))

      this.formData.ownAccounts = filteredAccounts
        .filter(a => this.nominatedAccountsConfig.enableNominatedAccountFeatures && a.ownAccount)
        .map(a => `${a.accountIdentification} - ${a.bankIdentifier}`)
    },
    fetchBeneficiariesList (accounts) {
      this.beneficiariesList = accounts || []
    },
    fetchSameAccounts (accounts) {
      this.sameAccountsNOCR = accounts
        .filter(a =>
          a.currency === this.config.productSummary.currencyCode &&
          a.postingsRestriction !== 'CREDIT' &&
          !['TXNA', 'TXEA', 'TXSV', 'TXFR', 'TXLA'].includes(a.accountType)
        )
        .map(a => ({
          ...a,
          value: `${a.accountType === 'CACC' ? this.$t('openDepositAcc.currentAccLabel') : this.$t('openDepositAcc.savingsAccLabel')} - ${a.accountId}`,
          text: `${a.accountType === 'CACC' ? this.$t('openDepositAcc.currentAccLabel') : this.$t('openDepositAcc.savingsAccLabel')} - ${a.accountId}`
        }))
    },
    termOptionHandler () {
      if (this.selectedTermOption) {
        this.formData.selectedTermOption = this.selectedTermOption.replace(/[^a-zA-Z ]/g, '')
      }
    },
    changeAccountType () {
      this.selectedPayAwayAcc = ''
      this.formData.selectedInterestPayAwayAcc = ''
      this.setPayAwayAC()
    }
  },
  beforeDestroy () {
    event.$off('listAccounts')
    event.$off('clearAccountsDetails')
    event.$off('onPreviousStep')
    event.$off('onNextStep')
    event.$off('IS_OTP_VALID')
    event.$off('createTermDepositAC')
  }
}
</script>

<style lang="scss" scoped>
.textFieldHighlighter {
  .v-text-field > .v-input__control > .v-input__slot:before {
    border-color: $defaultBorderColor !important;
    border-style: solid;
    border-width: 0.5px;
  }
}
</style>
